import { PropsWithChildren, useContext, useEffect } from 'react';
import type { Ref } from 'react';
import { KeypressContext } from '../Providers/keypressContext';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';

const simulateClickOnActiveEl = () => {
   const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
      buttons: 1,
   });
   document.activeElement?.dispatchEvent(event);
};

function Modal({
   ref,
   isOpen,
   onClose,
   children,
}: PropsWithChildren<MinimalDisclosure> & {
   ref?: Ref<HTMLDivElement>;
}) {
   const keypressContext = useContext(KeypressContext);

   useEffect(() => {
      const mappings = [
         { id: 'Modal', key: 'Escape', action: onClose },
         { id: 'Modal', key: ' ', action: simulateClickOnActiveEl },
      ];
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; key: string; actio... Remove this comment to see the full error message
      keypressContext.pushMappings(mappings);
      return () => {
         // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; key: string; actio... Remove this comment to see the full error message
         keypressContext.popMappings(mappings);
      };
   }, [keypressContext.pushMappings, keypressContext.popMappings, onClose]);

   // Block scroll when modal is open
   useEffect(() => {
      if (isOpen) {
         document.body.style.overflow = 'hidden';
         return () => {
            document.body.style.overflow = '';
         };
      }
   }, [isOpen]);

   if (!isOpen) {
      return null;
   }

   return (
      <>
         {/* Overlay */}
         <div
            className="fixed inset-0 backdrop-blur-[10px] z-[9998]"
            style={{ backgroundColor: 'rgba(227, 232, 237, 0.75)' }}
            onClick={onClose}
            onKeyDown={e => {
               if (e.key === 'Escape' && onClose) {
                  onClose();
               }
            }}
         />
         {/* Content */}
         <div
            className="fixed inset-0 w-screen h-screen bg-transparent outline-none z-[9999]"
            role="dialog"
            aria-modal="true"
         >
            <div ref={ref} className="w-full h-full p-0 m-0 overflow-auto">
               {children}
            </div>
         </div>
      </>
   );
}

export default Modal;
